<app-side-menu [(isExpanded)]="isMenuExpanded">
	<app-side-menu-tab-group>
		<app-side-menu-tab [isSelected]="hasFilter()" [isDisabled]="!hasFilter()">
			<ng-template appSideMenuTabLabel>
				<ogs-m3-icon prefix="fal" icon="sliders"/>
			</ng-template>
			<app-overview-settings-menu-filter/>
		</app-side-menu-tab>
				<app-side-menu-tab [isSelected]="true">
			<ng-template appSideMenuTabLabel>
				<ogs-m3-icon prefix="fal" icon="gear"/>
			</ng-template>
			<app-overview-settings-menu-fields/>
		</app-side-menu-tab>
	</app-side-menu-tab-group>
	</app-side-menu>
	